import { useState } from 'react';
import type { EditMobileNumberInitialFlow } from '../components/edit-mobile-number/types/edit-mobile-number';

type EditMobileNumberSheetOpenMode = Exclude<EditMobileNumberInitialFlow, 'edit'>;

type SettingsSheets = {
  showCloseAccountSheet: boolean;
  setShowCloseAccountSheet: (show: boolean) => void;
  showEditEmailSheet: boolean;
  emailStartOnVerify: boolean;
  setShowEditEmailSheet: (show: boolean, mode?: 'verify') => void;
  showEditMobileNumberSheet: boolean;
  mobileInitialFlow: EditMobileNumberInitialFlow;
  setShowEditMobileNumberSheet: (show: boolean, mode?: EditMobileNumberSheetOpenMode) => void;
  showContactPreferencesSheet: boolean;
  setShowContactPreferencesSheet: (show: boolean) => void;
  showChannelsSheet: boolean;
  setShowChannelsSheet: (show: boolean) => void;
  showAccountReviewReminderSheet: boolean;
  setShowAccountReviewReminderSheet: (show: boolean) => void;
};

function resolveMobileInitialFlow(mode?: EditMobileNumberSheetOpenMode): EditMobileNumberInitialFlow {
  if (mode === 'add') return 'add';
  if (mode === 'verify') return 'verify';
  return 'edit';
}

function useSettingsSheets(): SettingsSheets {
  const [showCloseAccountSheet, setShowCloseAccountSheet] = useState(false);
  const [showEditEmailSheet, setShowEditEmailSheet] = useState(false);
  const [emailStartOnVerify, setEmailStartOnVerify] = useState(false);
  const [showEditMobileNumberSheet, setShowEditMobileNumberSheet] = useState(false);
  const [mobileInitialFlow, setMobileInitialFlow] = useState<EditMobileNumberInitialFlow>('edit');
  const [showContactPreferencesSheet, setShowContactPreferencesSheet] = useState(false);
  const [showChannelsSheet, setShowChannelsSheet] = useState(false);
  const [showAccountReviewReminderSheet, setShowAccountReviewReminderSheet] = useState(false);

  const handleSetShowEditEmailSheet = (show: boolean, mode?: 'verify') => {
    setEmailStartOnVerify(show && mode === 'verify');
    setShowEditEmailSheet(show);
  };

  const handleSetShowEditMobileNumberSheet = (show: boolean, mode?: EditMobileNumberSheetOpenMode) => {
    setShowEditMobileNumberSheet(show);
    setMobileInitialFlow(show ? resolveMobileInitialFlow(mode) : 'edit');
  };

  return {
    showCloseAccountSheet,
    setShowCloseAccountSheet,
    showEditEmailSheet,
    emailStartOnVerify,
    setShowEditEmailSheet: handleSetShowEditEmailSheet,
    showEditMobileNumberSheet,
    mobileInitialFlow,
    setShowEditMobileNumberSheet: handleSetShowEditMobileNumberSheet,
    showContactPreferencesSheet,
    setShowContactPreferencesSheet,
    showChannelsSheet,
    setShowChannelsSheet,
    showAccountReviewReminderSheet,
    setShowAccountReviewReminderSheet,
  };
}

export { useSettingsSheets };
